import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../../../utils/constants';

interface Props {
  currentDepth: number;
}

export const AcceptAnswer = ({ currentDepth }: Props) => {
  // TODO add mutation to accept answer

  if (currentDepth !== 1) return null;

  return (
    <button css={acceptButtonStyles} type="button">
      Accept answer
    </button>
  );
};

const acceptButtonStyles = css({
  display: 'inline-block',
  alignSelf: 'flex-start',
  border: `2px solid ${token('color.background.success.bold')}`,
  color: token('color.background.success.bold'),
  background: 'transparent',
  borderRadius: '6px',
  padding: '4px 16px',
  fontWeight: 600,
  fontSize: '15px',
  marginBottom: '12px',
  cursor: 'pointer',
  transition: 'background 0.2s, color 0.2s',
  '&:hover': {
    background: token('color.background.success.bold'),
    color: token('color.text.inverse'),
  },
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '14px',
    padding: '3px 12px',
    marginBottom: '6px',
  },
});
